import cx from "classnames";

import styles from "./OfferBadge.module.scss";

type OfferBadgeVariant = "period" | "savings";

export interface OfferBadgeProps {
  children: React.ReactNode;
  variant?: OfferBadgeVariant;
}

export const OfferBadge = ({
  children,
  variant = "period",
}: OfferBadgeProps) => {
  return <span className={cx(styles.badge, styles[variant])}>{children}</span>;
};

export default OfferBadge;
